import { render, staticRenderFns } from "./table-registers.vue?vue&type=template&id=488e6f11&"
import script from "./table-registers.vue?vue&type=script&lang=js&"
export * from "./table-registers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports